import { motion } from "framer-motion";
import { ABOUT, IMAGES } from "@/data/content";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

export const About = () => {
  return (
    <section
      id="o-domu"
      data-testid="about-section"
      className="relative overflow-hidden bg-[#F9F7F3] py-20 md:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 md:px-10 lg:grid-cols-12 lg:gap-16">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          variants={fadeUp}
          className="lg:col-span-5"
        >
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#4A7055]">
            {ABOUT.eyebrow}
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-[#2D3728] text-balance md:text-4xl lg:text-5xl">
            {ABOUT.title}
          </h2>
          {ABOUT.paragraphs.map((p, i) => (
            <p
              key={i}
              className="mt-5 text-base leading-relaxed text-[#4A5D43] md:text-lg"
            >
              {p}
            </p>
          ))}

          <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {ABOUT.stats.map((s) => (
              <div
                key={s.label}
                data-testid={`about-stat-${s.label}`}
                className="rounded-2xl border border-[#E4DDCF] bg-white p-4 text-center"
              >
                <div className="font-display text-2xl font-semibold text-[#4A7055] md:text-3xl">
                  {s.value}
                </div>
                <div className="mt-1 text-xs font-medium uppercase tracking-wide text-[#8a9182]">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          variants={fadeUp}
          className="relative lg:col-span-7"
        >
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2 overflow-hidden rounded-3xl">
              <img
                src={IMAGES.beachSup}
                alt="Prywatna plaża z deskami SUP nad jeziorem Juno"
                className="h-64 w-full object-cover transition-transform duration-700 hover:scale-105 md:h-80"
              />
            </div>
            <div className="overflow-hidden rounded-3xl">
              <img
                src={IMAGES.bedroom}
                alt="Przytulna sypialnia"
                className="h-48 w-full object-cover transition-transform duration-700 hover:scale-105 md:h-64"
              />
            </div>
            <div className="overflow-hidden rounded-3xl">
              <img
                src={IMAGES.lakeForest}
                alt="Spokojne jezioro otoczone lasem"
                className="h-48 w-full object-cover transition-transform duration-700 hover:scale-105 md:h-64"
              />
            </div>
          </div>
          <div className="pointer-events-none absolute -bottom-6 -left-6 hidden h-24 w-24 rounded-full bg-[#9C5E4B]/15 blur-2xl md:block" />
        </motion.div>
      </div>
    </section>
  );
};
